export const headingTypes = [
    'hero',
    'display-1',
    'display-2',
    'display-3',
    'display-4',
    'display-5',
    'heading-1',
    'heading-2',
    'heading-3',
    'heading-4',
    'subtitle-1',
    'subtitle-2',
    'subtitle-3',
] as const;

export type HeadingType = (typeof headingTypes)[number];
